export enum DownloadType {
  RAW_DATA = 0,
  RESULTS_PER_ORG_UNIT = 1,
}

export const availableDownloadTypes: DownloadType[] = [
  DownloadType.RAW_DATA,
  DownloadType.RESULTS_PER_ORG_UNIT,
];

export const downloadTypeNames: { [key: number]: string } = {
  [DownloadType.RAW_DATA]: 'followUp:downloadType.RAW_DATA',
  [DownloadType.RESULTS_PER_ORG_UNIT]:
    'followUp:downloadType.RESULTS_PER_ORG_UNIT',
};
